import { render } from "./accountFormSelect.vue?vue&type=template&id=6360cefc&scoped=true"
import script from "./accountFormSelect.vue?vue&type=script&lang=js"
export * from "./accountFormSelect.vue?vue&type=script&lang=js"

import "./accountFormSelect.vue?vue&type=style&index=0&id=6360cefc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6360cefc"

export default script